( function($) {

    var WishlistFilter = ( function($) {

        WishlistFilter = function(options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$type_toggle = that.$wrapper.find("button.dropdown-toggle");

            that.$products = $(".b-search-wishlist-products .s-product-wrapper");

            //
            that.type = "all_types";
            that.rate = undefined;

            // INIT
            that.init();
        };

        WishlistFilter.prototype.init = function() {
            var that = this;

            that.$wrapper.on("click", ".js-wishlist-type-filter", function() {

                that.updateToggle($(this));

                that.type = $(this).data("filter");
                that.update();
            });

            that.$wrapper.on("change", ".js-wishlist-rate-filter", function() {
                that.rate = $(this).attr("checked");
                that.update();
            });
        };

        WishlistFilter.prototype.updateToggle = function($button) {
            var that = this,
                text = $button.text(),
                active_class = "active";

            that.$wrapper.find(".js-wishlist-type-filter").removeClass(active_class);
            $button.addClass(active_class);

            that.$type_toggle.html(text);
        }

        WishlistFilter.prototype.update = function() {
            var that = this,
                with_rate = that.rate === "checked";

            that.$products.each(function () {

                var state = false;
                var wishlist_filter = $(this).data("type");
                var wishlist_rate = $(this).data("rating");

                if (that.type === wishlist_filter || that.type === "all_types") {
                    state = true;
                }

                if (state === true) {
                    if (with_rate && wishlist_rate === 0) {
                        state = false;
                    }
                }

                if (state === true) {
                    $(this).removeClass("is-hidden");
                } else {
                    $(this).addClass("is-hidden");
                }

            });
        };

        return WishlistFilter;

    })(jQuery);

    window.waTheme.init.shop.WishlistFilter = WishlistFilter;

    var $wishlistFilters = $("#js-wishlist-filter").removeAttr("id");
    if ($wishlistFilters.length) {
        new window.waTheme.init.shop.WishlistFilter({
            $wrapper: $wishlistFilters
        });
    }


})(jQuery);

